import { Alert, Text, Link } from '@chakra-ui/react'

export function InfoBanner() {
  return (
    <Alert.Root
      status="info"
      variant="subtle"
      borderRadius="md"
      p={4}
      bg="blue.subtle" // #DBEAFE (from Figma)
      color="blue.fg"
      fontSize="xs"
      lineHeight={'16px'}
      mt={4}
    >
      {/* <AlertIcon /> */}
      <Alert.Indicator />

      <Alert.Description>
        <Text as="span" fontWeight="bold">
          Wenn Sie bereits ein aktives Abonnement der VBI-Software (
        </Text>

        <Link
          href="https://vbi.polygran.de/"
          color="blue.fg"
          fontWeight="normal"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://vbi.polygran.de/
        </Link>

        <Text as="span" fontWeight="bold">
          ) besitzen, wird kein neuer Kauf ausgelöst.
        </Text>

        <Text as="span">
          {' '}
          Ihr bestehendes Abo bleibt gültig, eine neue Rechnung erhalten Sie erst nach Ablauf der
          aktuellen Laufzeit.
        </Text>
      </Alert.Description>
    </Alert.Root>
  )
}
